import script from "./QuestionsText.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionsText.vue?vue&type=script&setup=true&lang=js"

import "./QuestionsText.vue?vue&type=style&index=0&id=d7507366&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7507366"]])

export default __exports__